import { FaSearch } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { FiEdit3 } from "react-icons/fi";

import { BsSortAlphaDown } from "react-icons/bs";
import { BsSortAlphaDownAlt } from "react-icons/bs";

import "../commonStyle.css";
import {
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UPDATE_CITIES_LIST } from "../../store/actionTypes";
import { debounce } from "lodash";
import CustomPagination from "../customPagination";
import ProperSpinner from "../spinner/ProperSpinner";
import { MdAdd } from "react-icons/md";
import CustomModal from "../customModal";
import { useFormik } from "formik";
import { addCitySchema } from "../../utils/validationSchema";
import CustomInputField from "../customInputField";
import { POST_API_CALL } from "../../utils/services";
import { ENDPOINTS } from "../../utils/endPoints";
import toast from "react-hot-toast";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../utils/showToast";
import { getCitiesList } from "../../views/cities/actions";
import AddressAutocomplete from "../customAutocomplete/AddressAutocomplete";
import Button from "@mui/material/Button";
import { getDateAndTimeFormatted } from "../../utils/commonFunctions";

/**
 * @function CitiesTable
 * @description for City Table
 * @returns JSX for City Table
 */

const CitiesTable = () => {
  const {
    citiesList,
    pageNo,
    totalPage,
    limit,
    searchKey,
    isLoading,
    sortOrder,
    sortBy,
  } = useSelector((state) => state.CityReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sortApplied, setSortApplied] = useState("cityName");
  const [inputValue, setInputValue] = useState(searchKey);
  const [show, setShow] = useState(false); // for Add sites Modal
  const [isManualCityEntry, setIsManualCityEntry] = useState(false); // for manual city entry
  const modalHandler = () => {
    setShow((prev) => !prev);
  };
  const modalClose = () => setShow(false);

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_CITIES_LIST,
      payload: { pageNo: page },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value;
    dispatch({
      type: UPDATE_CITIES_LIST,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handleDebounceFn = (input) => {
    dispatch({
      type: UPDATE_CITIES_LIST,
      payload: { searchKey: input, pageNo: 1 },
    });
  };
  const deBounceFn = useMemo(() => debounce(handleDebounceFn, 1000), []);

  const handleChange = (e) => {
    const text = e.target.value.replace(/[^a-zA-Z\s]/g, "").trimStart();
    setInputValue(text);
    if (text.length == 0 || text.length > 2) {
      deBounceFn(text);
    }
  };
  const handleClearInputField = () => {
    setInputValue("");
    deBounceFn("");
  };

  const handlerSort = (sortBy) => {
    setSortApplied(sortBy);
    dispatch({
      type: UPDATE_CITIES_LIST,
      payload: { sortBy: sortBy, sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };
  const [addressValue, setAddressValue] = useState({
    country: null,
    state: null,
    city: null,
  });
  const cityForm = useFormik({
    initialValues: {
      postalCode: "",
      city: "",
      state: "",
      country: "",
    },
    validationSchema: addCitySchema,
    onSubmit: async (values) => {
      const toastId = toast.loading("Adding city...");
      try {
        POST_API_CALL(ENDPOINTS.CITIES.ADD_CITY, values, (res) => {
          console.log("add city response", res);
          if (res?.isSuccess) {
            SUCCESS_TOAST("City has been added successfully");
            modalClose();
            cityForm.resetForm();
            dispatch(getCitiesList());
            setAddressValue({
              country: null,
              state: null,
              city: null,
            });
          }
        });
      } catch (error) {
        console.error("Error adding city:", error);
        ERROR_TOAST("Failed to add city");
      } finally {
        toast.dismiss(toastId);
      }
    },
  });

  const renderTableBody = () => {
    return (
      <CTableBody>
        {citiesList?.length > 0 &&
          citiesList?.map((city, i) => {
            const cityName = city?.cityName || "N/A";
            const state = city?.state || "N/A";
            const country = city?.country || "N/A";
            const pinCode1 = city?.pinCodes[0] || "N/A";
            const pinCode2 = city?.pinCodes[1] || null;
            const count = city?.pinCodes?.length - 2 || 0;
            return (
              <CTableRow key={city._id} className="table-data-text">
                <CTableDataCell className="text-center ">
                  {(pageNo - 1) * limit + i + 1}
                </CTableDataCell>
                <CTableDataCell
                  className="name-link "
                  onClick={() => navigate(`/cities/${city._id}`)}
                >
                  {cityName}
                </CTableDataCell>
                <CTableDataCell>{state}</CTableDataCell>
                <CTableDataCell>{country}</CTableDataCell>
                <CTableDataCell>
                  {pinCode1}
                  {pinCode2 && `, ${pinCode2}${count && ","} `}
                  {count > 0 ? (
                    <div className="tooltip-wrapper">
                      <span className="count-text-btn">{`+${count} more`}</span>
                      <div className="tooltip-box">
                        {city?.pinCodes?.map((code, idx) => (
                          <div key={idx} className="tooltip-item">
                            {code}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </CTableDataCell>
                <CTableDataCell>
                  {getDateAndTimeFormatted(city?.updatedAt)}
                </CTableDataCell>
                <CTableDataCell>
                  {getDateAndTimeFormatted(city?.createdAt)}
                </CTableDataCell>

                <CTableDataCell className=" text-center">
                  <FaRegEdit
                    className="actions-icons  cursor-pointer"
                    onClick={() => navigate(`/cities/update-city/${city._id}`)}
                  />
                </CTableDataCell>
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={limit}
        limitHanlder={pageLimitHandler}
        pageNo={pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    // if (!isLoading && !searchKey.length)
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            <span>{" Fetching cities "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" Cities "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };
  const modalBody = () => {
    return (
      <div className="report--management--modal--body--container">
        <div>
          <AddressAutocomplete
            url={"/admin/location/countries"}
            optionKeyToShow={"name"}
            name={"country"}
            label={"Country"}
            placeHolder={"Select country"}
            value={addressValue.country}
            setValue={(value) => {
              setAddressValue((prev) => ({
                ...prev,
                country: value,
                state: null,
                city: null,
                postalCode: "",
              }));
              cityForm.setFieldValue("country", value?.name);
              cityForm.setFieldValue("state", "");
              cityForm.setFieldValue("city", "");
              cityForm.setFieldValue("postalCode", "");
            }}
            changeHandler={cityForm.handleChange}
            disabled={false}
          />
          {cityForm.errors.country && cityForm.touched.country && (
            <div className="change-password-error">
              {cityForm.errors.country}
            </div>
          )}
        </div>
        <div>
          <AddressAutocomplete
            url={`/admin/location/states?countryCode=${addressValue.country?.isoCode}`}
            optionKeyToShow={"name"}
            name={"state"}
            label={"State"}
            placeHolder={"Select state"}
            value={addressValue.state}
            setValue={(value) => {
              console.log("set value called");
              setAddressValue((prev) => ({
                ...prev,
                state: value,
                city: null,
                postalCode: "",
              }));
              cityForm.setFieldValue("state", value?.name);
              cityForm.setFieldValue("city", "");
              cityForm.setFieldValue("postalCode", "");
            }}
            changeHandler={cityForm.handleChange}
            disabled={!addressValue.country?.isoCode}
          />
          {cityForm.errors.state && cityForm.touched.state && (
            <div className="change-password-error">{cityForm.errors.state}</div>
          )}
        </div>
        <div>
          <div className="d-flex align-items-end justify-content-between gap-1">
            {isManualCityEntry ? (
              <div className="w-100">
                <CustomInputField
                  label={"City"}
                  changeHandler={cityForm.handleChange}
                  name={"city"}
                  placeholder={"Enter city name"}
                  type={"text"}
                  value={cityForm.values.city}
                  blurhandler={cityForm.handleBlur}
                  readyOnly={
                    !(
                      addressValue.country?.isoCode &&
                      addressValue.state?.isoCode
                    )
                  }
                />
              </div>
            ) : (
              <AddressAutocomplete
                url={`/admin/location/cities?countryCode=${addressValue.country?.isoCode}&stateCode=${addressValue.state?.isoCode}`}
                optionKeyToShow={"name"}
                name={"city"}
                label={"City"}
                placeHolder={"Select city"}
                value={addressValue.city}
                setValue={(value) => {
                  console.log("set value called");
                  setAddressValue((prev) => ({
                    ...prev,
                    city: value,
                    postalCode: "",
                  }));
                  cityForm.setFieldValue("city", value?.name);
                  cityForm.setFieldValue("postalCode", "");
                }}
                changeHandler={cityForm.handleChange}
                disabled={
                  !(
                    addressValue.country?.isoCode && addressValue.state?.isoCode
                  )
                }
              />
            )}

            <Button
              variant="outlined"
              sx={{
                height: "38px",
                width: "38px",
                minWidth: "38px", // prevents MUI from forcing wider buttons
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
              disabled={
                !(addressValue.country?.isoCode && addressValue.state?.isoCode)
              }
              onClick={() => setIsManualCityEntry((prev) => !prev)}
            >
              {!isManualCityEntry ? (
                <FiEdit3 fontSize={18} />
              ) : (
                <FaSearch fontSize={18} />
              )}
            </Button>
          </div>

          {cityForm.errors.city && cityForm.touched.city && (
            <div className="change-password-error">{cityForm.errors.city}</div>
          )}
        </div>
        <div>
          <CustomInputField
            label={"Postal Code"}
            changeHandler={cityForm.handleChange}
            name={"postalCode"}
            placeholder={"Enter postal code name"}
            type={"text"}
            value={cityForm.values.postalCode}
            blurhandler={cityForm.handleBlur}
          />
          {cityForm.errors.postalCode && cityForm.touched.postalCode && (
            <div className="change-password-error">
              {cityForm.errors.postalCode}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <div className="table-header-container">
          <h3 className="w-50 mb-0 text-primary">{"Cities List"}</h3>
          <div className="d-flex justify-content-end align-items-center gap-1">
            <CInputGroup className="" style={{ width: "300px" }} size="sm">
              <CInputGroupText className="cursor-pointer">
                <FaSearch />
              </CInputGroupText>
              <CFormInput
                value={inputValue}
                name="text"
                onChange={handleChange}
                placeholder="Search city name"
              />
              {inputValue && (
                <CInputGroupText
                  className="cursor-pointer"
                  onClick={handleClearInputField}
                >
                  <RxCross2 />
                </CInputGroupText>
              )}
            </CInputGroup>

            <div
              className="btn btn-primary btn-sm add-btn add-btn-container"
              onClick={modalHandler}
            >
              <span>{"Add City"}</span>
              <span className="add-icon">
                <MdAdd />
              </span>
            </div>
            {/* <div className="border rounded-1 px-2 cursor-pointer filter-icon ">
              <FiFilter className="disabled-icons" />
            </div> */}
          </div>
        </div>
        <CTable hover responsive className="table-responsive">
          <CTableHead className="text-nowrap border">
            <CTableRow>
              <CTableHeaderCell className="bg-body-tertiary table-heading-5-cell">
                S. No.
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "cityName" ? "sort-highlight" : ""}`}
              >
                {"City Name"}
                <span onClick={() => handlerSort("cityName")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "state" ? "sort-highlight" : ""}`}
              >
                {"State"}
                <span onClick={() => handlerSort("state")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "country" ? "sort-highlight" : ""}`}
              >
                {"Country"}
                <span onClick={() => handlerSort("country")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-10-cell ${sortApplied === "pinCode" ? "sort-highlight" : ""}`}
              >
                {"Postal Code"}
                <span onClick={() => handlerSort("pinCode")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>

              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "updatedAt" ? "sort-highlight" : ""}`}
              >
                {"Updated At"}
                <span onClick={() => handlerSort("updatedAt")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "createdAt" ? "sort-highlight" : ""}`}
              >
                {"Created At"}
                <span onClick={() => handlerSort("createdAt")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>

              <CTableHeaderCell className="bg-body-tertiary  table-heading-10-cell text-center ">
                {"Actions"}
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {isLoading ? <ProperSpinner /> : renderTableBody()}
        </CTable>
        {(citiesList?.length >= 5 || pageNo > 1) && renderPagination()}
        {/* {!isLoading && citiesList?.length === 0 && renderNoDataFound()} */}
        {(isLoading || citiesList?.length == 0) && renderNoDataFound()}

        <CustomModal
          body={() => modalBody()}
          heading={"Add New City"}
          modalSize={"md"}
          confirmHandler={cityForm.handleSubmit}
          visible={show}
          visibleHandler={modalClose}
          confirmText="Save"
          footershow={true}
          closeText="Cancel"
        />
      </div>
    );
  };

  return <div>{renderView()}</div>;
};

export default CitiesTable;
